module.exports = __webpack_public_path__ + "img/figure8.03f76cba.jpeg";